import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useAuditLogs = (params: { entity: string; ids: string[] | number[] }) => {
  return useQuery({
    queryKey: [{ entity: "auditLogs", params }],
    queryFn: async () =>
      await apiClient.getAuditLogs({
        params: {
          entity: params.entity,
        },
        queries: {
          ids: params.ids,
        },
      }),
  });
};
